<template>
  <div v-if="carePlan">
    <form @submit.prevent="validateBeforeSubmit">
      <div class="row pb-4">
        <div class="col col-md-6 col-12">
          <div class="form-group">
            <label for="care-plan-title">Title</label>
            <b-form-input
              v-model="carePlan.title"
              v-validate="'required'"
              :class="{'danger': errors.has('careplanTitle') }"
              name="careplanTitle"
              type="text"
              placeholder="Care plan title"
            />
            <!-- <span
                  v-show="errors.has('careplan title')"
            class="error-text">Required</span>-->
          </div>
        </div>
        <div class="col col-md-6 col-12">
          <div class="form-group">
            <label for="category">Category</label>
            <b-form-select
              v-model="carePlan.category_id"
              v-validate="'required'"
              :class="{'danger': errors.has('category') }"
              :options="carePlanCategoryOptions"
              name="category"
              class="col-12"
            />
          </div>
        </div>
        <div class="col col-md-6 col-12">
          <div class="form-group">
            <label for="goal">Goal</label>
            <textarea
              v-model="carePlan.goal"
              v-validate="'required'"
              :class="{'danger': errors.has('goal') }"
              class="form-control"
              name="goal"
              placeholder="goal"
              rows="3"
            />
          </div>
        </div>
        <div class="col col-md-6 col-12">
          <div class="form-group">
            <label class="col-12 p-0" for="problem">Problem</label>
            <textarea
              v-model="carePlan.problem"
              v-validate="'required'"
              :class="{'danger': errors.has('problem') }"
              class="form-control"
              name="problem"
              placeholder="problem"
              rows="3"
            />
          </div>
        </div>
        <div class="row d-flex justify-content-around">
          <div class="col col-md-6 col-lg-6 col-12 row">
            <div class="col-md-4">
              <div class="form-group">
                <label class="col-12 p-0" for="plan-duration">Duration</label>
                <div class="d-flex align-items-center">
                  <b-form-select
                    v-model="carePlan.plan_duration"
                    v-validate="'required'"
                    :class="{'danger': errors.has('plan_duration') }"
                    :options="plan_duration"
                    name="plan_duration"
                  />
                  <span class="ml-1">days</span>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="col-12 p-0" for="cycle">Cycles</label>
                <div class="d-flex align-items-center">
                  <b-form-select
                    v-model.number="carePlan.cycles"
                    v-validate="'required'"
                    v-model="carePlan.cycles"
                    :class="{'danger': errors.has('cycles') }"
                    :options="cycleDuration"
                    name="cycles"
                    class="padding-left"
                  />
                  <span class="ml-1">times</span>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="col-12 p-0 text-nowrap" for="cycle-break">Break b/w cycles</label>
                <div class="d-flex align-items-center">
                  <b-form-select
                    v-model="carePlan.break_time"
                    v-validate="'required'"
                    :class="{'danger': errors.has('cycleBreak') }"
                    :options="cycleBreakDuration"
                    name="cycleBreak"
                  />
                  <span class="ml-1">days</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col col-md-6 col-lg-6 col-sm-6 col-12 row">
            <div class="col-md-6 col-lg-6 col-sm-6 col-12">
              <v-date-picker
                label="Start date"
                :minDate="getFormattedDate(plan_start_date)"
                :maxDate="getFormattedDate(carePlan.plan_end_date)"
                @onChange="value=> carePlan.plan_start_date = value"
                :value="defaultDateFormat(carePlan.plan_start_date)"
                v-validate="`required|earlier:${'Start date'},${carePlan.plan_end_date}`"
                :className="{'danger': errors.has('plan_start_date') }"
                name="plan_start_date"
              />
            </div>
            <div class="col-md-6 col-lg-6 col-sm-6 col-12">
              <v-date-picker
                label="End date"
                :minDate="getFormattedDate(carePlan.plan_start_date)"
                @onChange="value=> carePlan.plan_end_date = value"
                :value="defaultDateFormat(carePlan.plan_end_date)"
                v-validate="`required|after:${'End date'},${carePlan.plan_start_date}`"
                :className="{'danger': errors.has('plan_end_date') }"
                name="plan_end_date"
              />
            </div>
          </div>
        </div>
        <div class="row no-gutters col-12">
          <b-form-checkbox v-model="carePlan.is_enrollment" name="Enroll careplan">is Enrollment Careplan</b-form-checkbox>
        </div>
        <div class="col text-right">
          <b-button type="submit" variant="primary">{{ type === 'edit' ? 'Update' : 'Create' }} Plan</b-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import modules from "@/views/CarePlan/_modules";
import careplan from "@/mixins/careplan";
import SlotMixin from "@/mixins/slot";
import { mapGetters } from "vuex";
import moment from 'moment';

export default {
  name: "ModifyCareplan",
  mixins: [SlotMixin, careplan],
  props: {
    carePlan: { type: Object, required: true },
    type: { type: String, required: true }
  },
  data() {
    return {
      modules,
      plan_start_date : moment().subtract(30,'d').format('YYYY-MM-DD')    
    };
  },
  computed: {
    ...mapGetters({
      organisationId: "auth/getOrganisationId"
    })
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        const data = this.carePlan;
        data.organisation_id = this.organisationId;
        if (result) {
          this.$emit("onSubmit", data);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>
